<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item)"
    class="nav-item has-sub"
    :class="{
      open: isOpen,
      disabled: item.disabled,
      'sidebar-group-active': isActive,
    }"
  >
    <b-link
      class="d-flex align-items-center"
      @click="() => updateGroupOpen(!isOpen)"
    >
      <component
        v-if="item.customIcon"
        :is="item.customIcon"
        class="nav-bar-icon-color"
      />
      <feather-icon v-else :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ item.title }}</span>
      <nav-arrow-svg class="nav-bar-icon-color arrow-right" />
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <b-collapse v-model="isOpen" class="menu-content" tag="ul">
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from "bootstrap-vue";
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from "@core/layouts/utils";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { useUtils as useAclUtils } from "@core/libs/acl";
import VerticalNavMenuHeader from "../vertical-nav-menu-header";
import VerticalNavMenuLink from "../vertical-nav-menu-link/VerticalNavMenuLink.vue";

// Composition Function
import useVerticalNavMenuGroup from "./useVerticalNavMenuGroup";
import mixinVerticalNavMenuGroup from "./mixinVerticalNavMenuGroup";

const CustomerSVG = () => import("@/@core/components/svg/nav-bar/Customer.vue");
const ProductSvg = () => import("@/@core/components/svg/nav-bar/Product.vue");
const PrivilegeSVG = () =>
  import("@/@core/components/svg/nav-bar/Privileges.vue");
const ReportSvg = () => import("@/@core/components/svg/nav-bar/Report.vue");
const NavArrowSvg = () => import("@/@core/components/svg/nav-bar/NavArrow.vue");
const BannerSVG = () => import("@/@core/components/svg/nav-bar/Banner.vue");
const DataManageSVG = () =>
  import("@/@core/components/svg/nav-bar/IconDataManagement.vue");
const HoroscopedSVG = () =>
  import("@/@core/components/svg/nav-bar/HoroScope.vue");
const MissionSVG = () => import("@/@core/components/svg/nav-bar/Mission.vue");
const ArticleSVG = () => import("@/@core/components/svg/nav-bar/Article.vue");
const Survey = () => import("@/@core/components/svg/nav-bar/Survey.vue");
const TagSVG = () => import("@/@core/components/svg/nav-bar/IconTags.vue");
const FriendSVG = () =>
  import("@/@core/components/svg/nav-bar/IconFriends.vue");
const LotterySVG = () =>
  import("@/@core/components/svg/nav-bar/IconLottery.vue");
const UserSVG = () =>
  import("@core/components/svg/icon-navigation-bar/User.vue");
const CRMSVG = () => import("@core/components/svg/icon-navigation-bar/CRM.vue");
const PdpaSVG = () =>
  import("@core/components/svg/icon-navigation-bar/IconPdpa.vue");
const FulfillmentSVG = () =>
  import("@/@core/components/svg/nav-bar/Fulfillment.vue");
const DocumentSVG = () => import("@/@core/components/svg/nav-bar/Document.vue");
const ReportSVG = () => import("@/@core/components/svg/nav-bar/IconReport.vue");
const InventorySVG = () =>
  import("@/@core/components/svg/nav-bar/Inventory.vue");
const CustomSVG = () => import("@/@core/components/svg/nav-bar/Mission.vue");
const FlashDealSVG = () =>
  import("@/@core/components/svg/nav-bar/NavFlashDeal.vue");
const CommonSVG = () => import("@/@core/components/svg/nav-bar/IconCommon.vue");

export default {
  name: "VerticalNavMenuGroup",
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,

    //icon
    CustomerSVG,
    ProductSvg,
    InventorySVG,
    PrivilegeSVG,
    ReportSvg,
    NavArrowSvg,
    BannerSVG,
    DataManageSVG,
    HoroscopedSVG,
    MissionSVG,
    ArticleSVG,
    Survey,
    TagSVG,
    FriendSVG,
    LotterySVG,
    UserSVG,
    CRMSVG,
    PdpaSVG,
    FulfillmentSVG,
    DocumentSVG,
    ReportSVG,
    CustomSVG,
    FlashDealSVG,
    CommonSVG,
  },
  mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const {
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
    } = useVerticalNavMenuGroup(props.item);

    const { t } = useI18nUtils();
    const { canViewVerticalNavMenuGroup } = useAclUtils();

    return {
      resolveNavItemComponent,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuGroup,

      // i18n
      t,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/vertical-navbar.css";
</style>
